import {Stack, Typography} from '@mui/material';
import React from 'react';
import {CustomIconIllustration} from '../../styles';
import {RegistrationDataItemProps} from './types';

export function RegistrationDataItem({iconName, title, data}: RegistrationDataItemProps) {
	return (
		<Stack direction="row" alignItems="center" spacing={2}>
			<CustomIconIllustration customIconName={iconName} variant="primary" size="smaller" />
			<Stack direction="column" flex={1}>
				<Typography color="text.primary" variant="label" mb={0}>
					{title}
				</Typography>
				<Typography color="text.secondary" variant="body2">
					{data ?? '-'}
				</Typography>
			</Stack>
		</Stack>
	);
}
